import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import LandingPage from './components/LandingPage.jsx';
import AssessmentFlow from './components/AssessmentFlow.jsx';
import ReportPage from './components/ReportPage.jsx';
import AdminDashboard from './components/AdminDashboard.jsx';
import { AssessmentProvider } from './context/AssessmentContext.jsx';
import './App.css';

function App() {
  return (
    <AssessmentProvider>
      <Router>
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/assessment" element={<AssessmentFlow />} />
              <Route path="/report" element={<ReportPage />} />
              <Route path="/report/:orgCode/:userEmail" element={<ReportPage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AnimatePresence>
        </div>
      </Router>
    </AssessmentProvider>
  );
}

export default App;